module.exports = __webpack_public_path__ + "img/behaviour-1-mobile.7541a336.gif";